module.exports = __webpack_public_path__ + "static/media/blueline.7c7ba28f.svg";